const mapper = [];

// /platformbuy/ask
mapper.push({
  url: "/platformbuy/ask",
  method: "post",
  status: 400,
  message: "같은 회사 소속입니다.",
});
mapper.push({
  url: "/platformbuy/ask",
  method: "post",
  status: 409,
  message: "이미 구매요청 및 계약완료된 상품입니다.",
});
mapper.push({
  url: "/platformbuy/ask",
  method: "post",
  status: 418,
  message: "다른 유형의 상위 계약입니다.",
});

// /platformbuy/convert
mapper.push({
  url: "/platformbuy/convert",
  method: "post",
  status: 400,
  message: "같은 회사 소속입니다.",
});
mapper.push({
  url: "/platformbuy/convert",
  method: "post",
  status: 409,
  message: "이미 구매요청 및 계약완료된 상품입니다.",
});
mapper.push({
  url: "/platformbuy/convert",
  method: "post",
  status: 418,
  message: "다른 유형의 상위 계약입니다.",
});

const getMessageForAxiosStatus = (error) => {
  if (!error) {
    return undefined;
  }

  let message = "";
  if (error.response) {
    const findItem = mapper.find((map) => {
      const { status } = error.response;
      const { url, method } = error.response.config;

      return map.url === url && map.method === method && map.status === status;
    });

    if (findItem) {
      return findItem.message ?? message;
    }
  }

  return message;
};

export { getMessageForAxiosStatus };
